<template>
<div class="col-md-12 col-sm-12 col-xs-12 info-form-content p-l-r-0">
    <!-- <a href="#" class="preview " id="llppreview-btn" v-on:click="ifpreviewopen4()">
        <img src="../assets/privew-icon.png">
    </a>
    <a href="#" class="preview preview_btn-width" id="llppreview-close-btn" v-on:click="ifpreviewclose4()" style="display: none;">
        <img src="../assets/close-icon.png">
    </a> -->
    <div class="llp_form_block" id="llp_form_block" v-if="form_status">
        <div class="llp-accordion" id="accordionllp" role="tablist">
            <b-card no-body class="mb-1" v-for="(f,key) in directors" :key="key">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'accordion-' + key" variant="info">Partner - {{key+1}} (LLP) <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse :id="'accordion-'+key" visible accordion="llp-accordion" role="tabpanel">
                     <b-card-body>
                        <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon">
                            <a href="#"><img src="../assets/edit_icon.png"></a>
                        </div> -->
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left">
                                <label for="name">Name (in full)*</label>
                                <input type="text" class="form-control" id="name" v-model="f.name">
                                <span class="text-danger" v-if="presentKey==key && validation_errors.name">Please enter name</span>
                            </div>
                            <div class="form-group col-md-6 p-r-0 f-left">
                                <label for="fname">Father’s Name (in full)*</label>
                                <input type="text" class="form-control" id="fname" v-model="f.father_name">
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.father_name">Please enter father name</span>
                            </div>
                        </div>

                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left">
                                <label for="mobile_no">Mobile Number*</label>
                                <input type="text" class="form-control" id="mobile_no" v-model="f.mobile_no">
                                <span class="teptext">(Linked with Aadhar)</span>
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.mobile_no">{{validation_errors.mobile_no}}</span>
                            </div>
                            <div class="form-group col-md-6 p-r-0 f-left">
                                <label for="email_id">Email ID*</label>
                                <input type="text" class="form-control" id="email_id" v-model="f.email_id">
                                <span class="text-danger" v-if="presentKey==key && validation_errors.email_id">{{validation_errors.email_id}}</span>
                            </div>
                        </div>
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left">
                                <label for="'Birth'">Date of Birth*</label>
                                <!-- <input type="text" class="form-control" id="Birth" v-model="f.dob"> -->
                                <Datepicker class="form-control" v-model="f.dob"></Datepicker>
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.dob">Please select date of birth</span>
                            </div>
                            <div class="form-group col-md-6 p-r-0 f-left">
                                <label for="Qualification">Highest Educational Qualification*</label>
                                <input type="text" class="form-control" id="Qualification" v-model="f.higest_education">
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.higest_education">Please enter higest education</span>
                            </div>
                        </div>
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left">
                                <label for="Occupation">Occupation*</label>
                                <input type="text" class="form-control" id="Occupation" v-model="f.occupation">
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.occupation">Please enter occupation</span>
                            </div>

                            <div class="form-group col-md-6 p-r-0 f-left">
                                <label for="PanNumber">PAN Number*</label>
                                <input type="text" class="form-control" id="PanNumber" v-model="f.pan_number">
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.pan_number">Please enter pan number</span>
                            </div>
                        </div>
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left">
                                <label for="address">Address*</label>
                                <textarea class="form-control form_textarea" rows="4" id="address" v-model="f.address"></textarea>
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.address">Please enter address</span>
                            </div>
                        </div>

                        <div class="col-md-12 p-l-r-0 f-left proof_upload">
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                    <address_proof_acc v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                    <span id="file-chosen" v-if="f.address_proff">
                                        <a :href="f.address_proff" target="_blank">view</a>
                                    </span>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.address_proff">Please upload address proof</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                    <pan_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                    <span id="file-chosen" v-if="f.pan_url">
                                        <a :href="f.pan_url" target="_blank">view</a>
                                    </span>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.pan_url">Please update self-attested PAN document</span>
                                </div>
                                <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                    <aadhar_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                    <span id="file-chosen" v-if="f.aadhar_url">
                                        <a :href="f.aadhar_url" target="_blank">view</a>
                                    </span>
                                         <span class="text-danger" v-if="presentKey==key && validation_errors.aadhar_url">Please update self-attested Aadhar document</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                    <photo_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                    <span id="file-chosen" v-if="f.passport_size_photo">
                                        <a :href="f.passport_size_photo" target="_blank">view</a>
                                    </span>
                                         <span class="text-danger" v-if="presentKey==key && validation_errors.passport_size_photo">Please update passport size photo</span>
                                </div>
                            </div>
                        </div>
                        <!-- <proof_upload :subscription_id="props_from_parent" :which_director="key" @UpdateFilePath="UpdateFilePath"/> -->
                        <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>

                        <!-- digital signature -->
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Qualification">Do you have Digital Signature Certificate?*</label><br>
                                    <label class="radio-container">Yes
                                        <input type="radio" value="yes" v-model="f.dsc" v-on:click="ifyessignature('yes',key)">
                                        <span class="checkmark"></span>
                                        
                                    </label>
                                    <label class="radio-container">No
                                        <input type="radio" value="no" v-model="f.dsc" v-on:click="ifyessignature('no',key)">
                                        <span class="checkmark"></span>
                                    </label>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.dsc">Please select</span>
                                    <!-- <p class="signaure-text" :id="'signaure-text-'+key" style="color: #F75511;">Upon form completion and its approval by your accounting manager, an option to add DSC will be enabled for forms MBP-1 and DIR-2.</p> -->
                                    <!-- <p class="signaure-text" :id="'signaure-text-'+key" style="color: #F75511;">Upon form completion and its approval by your accounting manager, an option to add DSC will be enabled for forms MBP-1 and DIR-2.</p> -->
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Qualification">Do you have Director Identification Number (DIN)?*</label><br>
                                    <label class="radio-container">Yes
                                        <input type="radio" value="yes" v-model="f.din" id="ifyes">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">No
                                        <input type="radio" value="no" v-model="f.din">
                                        <span class="checkmark"></span>
                                    </label>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.din">Please select</span>
                                    <input type="text" class="form-control" style="margin-top: 10px;" v-model="f.din_other" v-if="f.din=='yes'" :id="'din_text_box_'+key" placeholder="Enter DIN">
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Qualification">Are you an Indian citizen?* </label><br>
                                    <label class="radio-container">Yes
                                        <input type="radio" value="yes" v-model="f.citizen_of_india">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">No
                                        <input type="radio" value="no" v-model="f.citizen_of_india">
                                        <span class="checkmark"></span>
                                    </label>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.citizen_of_india">Please select</span>
                                    <input type="text" class="form-control" style="margin-top: 10px;" v-if="f.citizen_of_india=='no'" v-model="f.citizen_of_other" :id="'country_name_'+key" placeholder="Country Name*">
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="percentage">Ownership percentage*</label>
                                    <input type="text" class="form-control" v-model="f.ownership_percentage" id="percentage">
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.ownership_percentage">Please enter ownership percentage</span>
                                </div>
                            </div>

                        </div>
                        <!-- digital signature end -->
                        <!-- nature_interest -->
                        <div class="col-md-12 p-l-r-0 f-left">
                            <div class="form-group col-md-6 p-l-r-0 f-left intrestedentity">
                                <label for="entity">    Do you have an interest in any other entity?* </label><br>
                                <label class="radio-container">Yes
                                    <input type="radio" value="yes" v-model="f.intrested_in_other_entity" v-on:click="ifyesintrest('yes',key)">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="radio-container">No
                                    <input type="radio" value="no" v-model="f.intrested_in_other_entity" v-on:click="ifyesintrest('no',key)">
                                    <span class="checkmark"></span>
                                </label>
                                 <span class="text-danger" v-if="presentKey==key && validation_errors.intrested_in_other_entity">Please select</span>
                            </div>
                            <div class="form-group col-md-6 p-r-0 f-left">
                                <label for="designated_partner">    Are you a designated partner?* </label><br>
                                <label class="radio-container">Yes
                                    <input type="radio" value="yes" v-model="f.designated_partner">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="radio-container">No
                                    <input type="radio" value="no" v-model="f.designated_partner">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-12 p-l-r-0 f-left" :id="'nature_interest_form_'+key" v-if="f.intrested_in_other_entity=='yes'">
                            <div class="col-md-12 p-l-r-0 f-left sub-text">
                                <span>Nature of interest (owner/partner/director etc.)*</span>
                            </div>
                            <div v-for="(list,listkey) in f.nature_interest_list" :key="listkey" class="col-md-12 f-left nature_interest_box" style="padding-bottom:10px">
                                <a href="javascript://" v-if="listkey>0" @click="RemoveIntrestList(listkey,key)">Remove</a>
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-l-r-0 f-left">
                                        <label for="nEntity">Name of the Entity*</label>
                                        <input type="text" class="form-control" v-model="list.entity_name" id="nEntity">
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left">
                                        <label for="nInterest">Nature of interest (owner/partner/director etc.)*</label>
                                        <input type="text" class="form-control" v-model="list.nature_interest_interest" id="nInterest">
                                    </div>
                                </div>
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-l-r-0 f-left">
                                        <label for="inr">Value in INR*</label>
                                        <input type="text" class="form-control" v-model="list.value" id="inr">
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left">
                                        <label for="datepicker">Date*</label>

                                        <!-- <input type="text" class="form-control" v-model="list.date" id="datepicker"> -->
                                        <Datepicker class="form-control" v-model="list.date"></Datepicker>
                                        <span class="teptext">on which Interest arose</span>
                                    </div>
                                </div>
                            </div>
                            <div class="pluse-icon">
                                <a href="javascript://" @click="NaruteoFPlus(key)"><img src="../assets/pluse-icon.png"></a>
                            </div>

                        </div>
                        <!-- nature_interest end -->

                        <div class="col-md-12 p-l-r-0 f-left submit_btn_margin">
                            <button type="button" class="btn btn-primary gobtn submit" @click="Submit(key)">
                                <span v-if="key < directors_count-1 ">
                                    Next
                                </span>
                                <span v-else>
                                    Submit
                                </span>
                            </button>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordionllp-3 variant="info">Other Details (LLP) <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordionllp-3" accordion="llp-accordion" role="tabpanel" class="other_details-sec">
                    <b-card-body>
                        <form>
                            <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon" style="margin-bottom: 0px">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div> -->
                            <other_llp_details :props_to_child="props_from_parent" :propdata="other_details" :parentName="'llp'"  @other_update="saveSuccess"/>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
    <div v-else class="llp_form_priview_block priview_block" id="llp_form_priview_block">
        <llp_form_preview :prop_owners="directors" :prop_others="other_details" />
    </div>
</div>
</template>

<script>
import company_info from "../services/company_info"
// import proof_upload from './proof_upload';
// import digitel_signature from './digital_signature';
// import nature_interest from './nature_interest';
import address_proof_acc from './address_proof';
import aadhar_upload from './aadhar_upload';
import photo_upload from './photo_upload';
import pan_upload from './pan_upload';
import other_llp_details from './other_llp_details';
import llp_form_preview from './llp_form_preview';
import Datepicker from 'vuejs-datepicker';
export default {
    name: 'LLP_accordion',
    props: ['no_of_directors', 'subscription_params'],
    watch: {
        subscription_params: {
            handler: function () {
                this.InitPrepareForm();
            },
            immediate: true
        },
        no_of_directors: function (data) {
            this.directors_count = data.dir
            this.InitPrepareForm();
        },
    },
    components: {
        // proof_upload,
        // digitel_signature,
        // nature_interest,
        other_llp_details,
        llp_form_preview,
        address_proof_acc,
        aadhar_upload,
        pan_upload,
        photo_upload,
        Datepicker
    },
    data() {
        return {
            directors_count: 2,
             presentKey:'',
            validation_errors: {
            },
            props_from_parent: {
                subscribtion_id: '',
                folder_id: '',
                type: ''
            },
            form_status: true,
            other_details: {
                subscription_id: this.subscription_params.subscribtion_id,
                website: '',
                entity: 'LLP',
                brief_note: '',
                designated_partners_name_option1: '',
                esignated_partners_name_option2: '',
                llp_name_option1: '',
                llp_name_option2: '',
                contribution: '',
                any_utility_bill_url: '',
                noc: '',
                registered_office_doc_url: '',
                registered_office: '',

            },
            directors: [],
        }
    },
    methods: {
        InitPrepareForm() {
            this.directors_count = this.no_of_directors.dir;
            this.directors = [];
            var db_params = this.subscription_params.company_info;
            if (db_params) {
                this.form_status = db_params.status == 'pending' ? true : false;
                if (db_params.other_details) {
                    this.other_details = JSON.parse(db_params.other_details);
                }
                if (db_params.onwer_information!=null) {
                    var res_format = JSON.parse(db_params.onwer_information);
                    for (var j = 0; j < db_params.no_of_owners; j++) {
                        this.directors.push(res_format[j]);
                    }

                } else {
                    this.prePareForm();
                }
            } else {
                this.prePareForm();
            }

            this.UpdateChildPropData();
        },
        prePareForm() {
            for (var i = 1; i <= this.directors_count; i++) {
                this.directors.push({
                    name: '',
                    father_name: '',
                    mobile_no: '',
                    email_id: '',
                    dob: '',
                    higest_education: '',
                    occupation: '',
                    pan_number: '',
                    address: '',
                    aadhar_url: '',
                    pan_url: '',
                    address_proff: '',
                    passport_size_photo: '',
                    dsc: '',
                    din: '',
                    din_other: '',
                    citizen_of_india: '',
                    citizen_of_other: '',
                    intrested_in_other_entity: '',
                    ownership_percentage: '',
                    designated_partner: '',
                    nature_interest_list: []
                });
            }
        },
        Submit(from) {
            this.validation_errors={}
             this.presentKey=from
            company_info.post({
                    onwer_information: this.directors[from],
                    onwer_information_all: this.directors,
                    subscription_id: this.subscription_params.subscribtion_id,
                    no_of_owners: this.no_of_directors.dir,
                    entity: 'LLP',
                    validate_index: from
                })
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                         // open next form
                         if (from < this.directors.length - 1) {
                            var accordian = from + 1
                            document.getElementById('accordion-' + accordian).style.display = 'block';
                            document.getElementById('accordion-' + from).style.display = 'none';
                        }
                    }
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                        var temp={};
                        Object.keys(err).forEach((key) => {
                            var err_text=err[key][0].split(".");
                            temp[key.split(".")[1]]=err_text[1]
                        });
                        this.validation_errors=temp
                    }
                })
        },
         saveSuccess(payload){
             this.$emit("saveSuccessToparent", {
                    src: payload.src
                });
        },
        UpdateChildPropData() {
            this.props_from_parent = this.subscription_params
            this.props_from_parent.date = new Date()

        },
        UpdateFilePath(payload) {
            if (payload.src == 'address_proff') {
                this.directors[payload.action].address_proff = payload.url;
            }
            if (payload.src == 'aadhar_url') {
                this.directors[payload.action].aadhar_url = payload.url;
            }
            if (payload.src == 'pan_url') {
                this.directors[payload.action].pan_url = payload.url;
            }
            if (payload.src == 'passport_size_photo') {
                this.directors[payload.action].passport_size_photo = payload.url;
            }
        },
        ifyesintrest(option, DirKey) {
            if (option == 'yes') {
                // document.getElementById('nature_interest_form_' + DirKey).style.display = 'block';
                this.NaruteoFPlus(DirKey)
            } else {
                this.directors[DirKey].nature_interest_list = []
                // document.getElementById('nature_interest_form_' + DirKey).style.display = 'none';
            }
        },
        NaruteoFPlus(DirKey) {
            this.directors[DirKey].nature_interest_list.push({
                entity_name: '',
                nature_interest_interest: '',
                value: '',
                date: ''
            });
        },
        RemoveIntrestList(listKey, DirKey) {
            this.directors[DirKey].nature_interest_list.splice(listKey, 1);
        },
        ifyessignature(option, DirKey) {
            if (option == 'yes') {
                document.getElementById('signaure-text-' + DirKey).style.display = 'block';
            } else {
                document.getElementById('signaure-text-' + DirKey).style.display = 'none';
            }
        },

        ifpreviewopen4() {
            document.getElementById('llp_form_priview_block').style.display = 'block';
            document.getElementById('llp_form_block').style.display = 'none';
            document.getElementById('llppreview-btn').style.display = 'none';
            document.getElementById('llppreview-close-btn').style.display = 'block';
        },
        ifpreviewclose4() {
            document.getElementById('llp_form_priview_block').style.display = 'none';
            document.getElementById('llp_form_block').style.display = 'block';
            document.getElementById('llppreview-btn').style.display = 'block';
            document.getElementById('llppreview-close-btn').style.display = 'none';
        }
    }
};
</script>
